import UniversityIcon from './UniversityIcon';
import GraduateIcon from './GraduateIcon';
import PatientIcon from './PatientIcon';
import CalendarBookedIcon from 'src/components/svg/doctor/CalendarBookedIcon';
import Check from './Check';
import Droplet from './Droplet';

const index = {
  'university-icon': UniversityIcon,
  'graduate-icon': GraduateIcon,
  'patient-icon': PatientIcon,
  'calendar-booked-icon': CalendarBookedIcon,
  DOCTOR_CHECK: Check,
  DROPLET: Droplet
};

export const DOCTOR_ICONS = {
  DOCTOR_CHECK: 'DOCTOR_CHECK',
  DROPLET: 'DROPLET'
};

export default index;
